import { is, allPass, complement } from 'ramda'

export const isUndefined = (x) => typeof x === 'undefined'
export const isNumber = is(Number)
export const isString = is(String)
export const isArray = is(Array)
export const isObject = allPass([is(Object), complement(isArray)])
export const isFunction = is(Function)
